import * as React from "react";
import {
  Routes,
  Route,
  Link,
  Swit,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";

import { Container, ThemeProvider, Typography } from "@mui/material";

import Alarms from './alarms/Alarms';
import SOC from './alarms/SOC';
import DismissedAlarms from './alarms/DismissedAlarms';
import ApiDown from "./Report/History/ApiDown";
import ApiZabbix from './ApiZabbix';
import Audit from "./Report/Audit";
import { AuthProvider, RequireAuth } from './auth/AuthProvider';
import ChangePassword from "./recovery/changePassword";
import Dashboard from './dashboard/Dashboard';

import HistoryReport from './Report/History';
import LoginPage from './Login/LoginPage';
import Map from './Map';
import { MenuContextProvider } from "./Map/MenuContext";
import Monitor from "./Monitor";
import NotAuth from "./NotAuth";

import PPI from "./PPI";
import PPIGroup from "./PPI/Groups";
import PainelNOC from './PainelNOC';
import Recover from "./recovery/";
import Role from "./User/Role";
import SecuritySettings from "./profile/SecuritySettings";


import theme from "./theme";
import Token from "./Token";
import TwoFactorVerify from './auth/TwoFactorVerify';
import User from "./User";
import UserOnline from "./User/UserOnline";
import UsersReport from './Report/Users';
import ApiWazuhES from './ApiWazuhES';
import Webhook from './Webhook';
import AthenaConfig from './AthenaConfig';

export default function App() {
  return (
    <AuthProvider>
      <MenuContextProvider>

    <Routes>
        <Route>
          <Route path="/" element={
            <RequireAuth >
                <Dashboard />
              </RequireAuth>
            }>
                <Route path="/" element={
                  <Alarms/>
                }/>     
          <Route path="/soc"
            element={<SOC/>}/>
          <Route path="/dismissed-alarms"
            element={<DismissedAlarms/>}/>
          <Route path="/map"
            element={<Map/>}/>
          <Route path="api"
            element={<ApiZabbix/>}/>
          <Route path="api-wazuh"
            element={<ApiWazuhES/>}/>
          <Route path="user"
            element={<User/>}/>
          <Route path="user/online"
            element={<UserOnline/>}/>
          <Route path="user/role"
            element={<Role/>}/>
          <Route path="painel-noc"
            element={<PainelNOC/>}/>
          <Route path="report/history"
            element={<HistoryReport/>}/>
          <Route path="report/users"
            element={<UsersReport/>}/>
          <Route path="report/audit"
            element={<Audit/>}/>
          <Route path="token"
            element={<Token/>}/>
          <Route path="ppi/group"
            element={<PPIGroup/>}/>
          <Route path="ppi"
            element={<PPI/>}/>
          <Route path="report/api-down"
            element={<ApiDown/>}/>
          <Route path="settings/security"
            element={<SecuritySettings/>}/>
          <Route path="webhooks"
            element={<Webhook/>}/>
          <Route path="athena-config"
            element={<AthenaConfig/>}/>

          <Route path="/401" element={<NotAuth />} />

          
            <Route path='*' element={<NotFound />}/>
            </Route>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/2fa" element={<TwoFactorVerify />} />
          <Route path="/recovery" element={<Recover />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Route>
      </Routes>
      </MenuContextProvider>
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <Container  maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
    <ThemeProvider theme={theme}>
    <Typography component="h2" variant="h6" color="primary" gutterBottom>
      Página não encontrada.
    </Typography>
    </ThemeProvider>
      </Container>
  )
}